import styles from "./loader.module.scss";
import { Flex, Spin } from "antd";
import { useEffect, useState } from "react";
import { useRef } from "react";

function Loader() {
  const [loading, setLoading] = useState<boolean>(false)
  const timer = useRef<NodeJS.Timeout | undefined>();

  useEffect(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      setLoading(true);
    }, 300);

    return () => {
      clearTimeout(timer.current);
      timer.current = undefined;
      setLoading(false);
    }
  }, []);
  return loading ? (
    <Flex align="center" gap="middle" className={styles.container}>
      <Spin size="large" />
    </Flex>
  ) : null;
}

export default Loader;
